<div (click)="onSelect()" [ngClass]="{ disabled: disabled }">
	<h4 [ngClass]="{ tailored: item.tailored }">
		{{ itemLabel }}
		<span *ngIf="childrenCount > 0" class="counter">{{ childrenCount }}</span>
	</h4>
	<h6>{{ itemType }}</h6>
</div>
